import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { CustomShirtBuilder } from './components/CustomShirtBuilder';
import { BestSellers } from './components/BestSellers';
import { GameDayCategories } from './components/GameDayCategories';
import { LocalTrustSection } from './components/LocalTrustSection';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <HowItWorks />
      <CustomShirtBuilder />
      <BestSellers />
      <GameDayCategories />
      <LocalTrustSection />
      <Newsletter />
      <Footer />
    </div>
  );
}
